import { computed } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { FindAllSelectAction } from "../../actions/marcaVehiculosActions";

export function useMarcaVehiculoSelect() {
  
  const query = useQuery({
    queryKey: ["MarcaVehiculosList"],
    queryFn: () => FindAllSelectAction(),
    staleTime: 60 * 1000,
  });

  const marcas = computed(() => query.data.value?.data?.data || []);

  return {
    ...query,
    marcas,
  };
}
